import { useCallback, useContext, useState } from "react";
import { callPostApi } from "../../function/ApiCallFunction";
import { Button, Box, TextField, Typography } from "@mui/material";
import { toast } from 'react-toastify';
import { Link} from "react-router-dom";
import { DataContext } from "../../context/DataContext";

function Login({ onLogin }) 
{
    const [username, setUsername] = useState(""); 
    const [password, setPassword] = useState("");
    const [loading,  setLoading]  = useState(false);

    const { setLoginData } = useContext(DataContext); // Access setLoginData from DataContext


    // ------------------ Validation ------------------
    const validate = useCallback(() => 
    {
        if (!username.trim()) { toast.error("Username is required"); return false; }
        if (!password.trim()) { toast.error("Password is required"); return false; }
        return true;
    }, [username,password]);

    // ------------------ Submit ------------------
    const handleSubmit = async (e) => 
    {
        e.preventDefault();
        if (!validate()) return;
        setLoading(true);

        try 
        {
            const payload = { mod: "STORE_LOGIN", data_arr: { username: username.trim(), password: password.trim(), },};
            
            const apiResult = await callPostApi("store-login", payload);

            if (apiResult.status === "200" && apiResult.data) 
            { 
                toast.success("Login successfully!" ,{ autoClose: 1000,});

                const successData = apiResult.data; 

                // ✅ Update Context
                setLoginData(successData);
                sessionStorage.setItem("loginData", JSON.stringify(successData));
              
                onLogin(successData); 
            } 
            else 
            {
                toast.error(apiResult?.data?.error || "Invalid username or password",{ autoClose: 1500 });
            }
       } 
       catch (error) { toast.error("Something went wrong. Please try again."); }
       finally { setLoading(false); }
    };

  return (
    <>

      <Box className="login" display="flex" justifyContent="center" alignItems="center" flexDirection="column" height="100vh"> 
          
          <Box className="login-box" elevation={3} sx={{ padding: 4, width: 300 }}> 

              <Box className='text-center'> <img src="images/cashilogo.png" alt="logo" height="30px" width="auto" /> </Box> 

              <Typography variant="h5" mb={1} mt={2} sx={{color:'#ffffff'}}>Sign In</Typography> 
              <form onSubmit={handleSubmit}> 
                <TextField className="transparent-textfield" fullWidth margin="normal" label="Username" required variant="filled" 
                  value={username} onChange={(e) => setUsername(e.target.value)} /> 

                <TextField className="transparent-textfield" fullWidth margin="normal" label="Password" type="password" required variant="filled" 
                    value={password} onChange={(e) => setPassword(e.target.value)} /> 

                <Button type="submit" variant="gradient" fullWidth sx={{ mt: 2, background: 'linear-gradient(195deg, #49a3f1, #1A73E8)',
                  color:'#ffffff', '&.Mui-disabled': { color: '#ffffff',} }} disabled={loading}> {loading ? "Logging in..." : "Login"} </Button> 

              </form> 
          </Box> 
      
          <Box sx={{ position: "fixed", bottom: 0, left: 0, width: "100%", background: "linear-gradient(195deg, #49a3f1, #1A73E8)",
              color: "#fff", display: "flex", justifyContent: "space-around", alignItems: "center", py: 1, zIndex: 1200, }}>
          
              <Typography variant="body2">
                © {new Date().getFullYear()} <Link to="/home" style={{textDecoration:'none', color:'#fff'}}>Cashi.</Link> All rights reserved.
              </Typography>

              <Link to="https://cashi.in/" style={{textDecoration:'none', color:'#fff'}} target='_blank'>
              <Typography variant="link">www.cashi.in</Typography></Link>
        </Box>
    
    </Box>
    </>
  
  );
}

export default Login;